import { VarItem } from "@/@types/manageVars";

export interface Node {
  node: number;
  id: number;
  variable: VarItem;
  api_output_variable?: VarItem;
  child?: Node[];
  type: NodeType;
}

export enum NodeType {
  Message = 1,
  Options = 2,
  SingleOption = 3,
  Buttons = 4,
  ButtonOption = 5,
  List = 6,
  ListSection = 7,
  ListSectionItem = 8,
  Card = 9,
  CardSection = 10,
}

export interface ChatbotDetails {
  variables?: VarItem[];
}

export enum WaitTimeAction {
  None = 1,
  Resolve = 2,
  Transfer = 3,
}

export interface ChatbotDetails {
  // ...agregar más propiedades
  wait_time_action: WaitTimeAction;
  timer: number;
  timer_message: string;
  portfolio: number;
  queue: number;
}

export interface MediaNode {
  filename: string;
  media?: string;
  media_type: string;
  media_url: string;
  wrong_answer_media?: string;
  wrong_answer_media_filename: string;
  wrong_answer_media_type: string;
  wrong_answer_media_url: string;
}

export interface Node extends MediaNode {
  node: number;
  id: number;
}
